import EmptyImagePlaceholder from '@/assets/images/placeholders/images/placeholder-image-square.jpg';
import { FACEBOOK, INSTAGRAM } from '@/config/constants';
import type { AdCampaignDraftStatus } from '@/redux/slices/adManager/adManager';
import type { LomavisCampaignBuilderPlacement1 } from '@/lomavisSharedUi/templates/sections/LomavisCampaignBuilder1';

import type { AdPreviewPlatform } from './types';

export const defaultPlacements: LomavisCampaignBuilderPlacement1[] = [
  {
    id: 'facebook-feed',
    label: 'Facebook feed',
    platform: 'facebook',
    selected: true
  },
  {
    id: 'facebook-stories',
    label: 'Facebook stories',
    platform: 'facebook',
    selected: false
  },
  {
    id: 'instagram-feed',
    label: 'Instagram feed',
    platform: 'instagram',
    selected: true
  },
  {
    id: 'instagram-stories',
    label: 'Instagram stories',
    platform: 'instagram',
    selected: false
  }
];

export const MIN_AGE = 13;
export const MAX_AGE = 65;
export const MIN_RADIUS_KM = 17;
export const MAX_RADIUS_KM = 80;
export const SPECIAL_AD_CATEGORY_MIN_RADIUS_KM = 25;
export const SUPPORTED_MEDIA_FORMATS_LABEL = 'MP4, MOV, JPEG, and PNG';
export const AD_MANAGER_MEDIA_ACCEPT =
  'image/jpeg,image/png,video/mp4,video/quicktime,.jpg,.jpeg,.png,.mp4,.mov';
export const EMPTY_CAMPAIGN_THUMBNAIL = `url("${String(
  EmptyImagePlaceholder
)}") center / cover`;

export const draftStatusKeyByValue: Record<number, AdCampaignDraftStatus> = {
  0: 'draft',
  1: 'publishing',
  2: 'published',
  3: 'failed'
};

export const previewProfileFallbackName: Record<AdPreviewPlatform, string> = {
  [FACEBOOK]: 'Facebook page',
  [INSTAGRAM]: 'Instagram account'
};

export const REAL_SPECIAL_AD_CATEGORY_IDS = new Set([
  'HOUSING',
  'EMPLOYMENT',
  'FINANCIAL_PRODUCTS_SERVICES',
  'ISSUES_ELECTIONS_POLITICS'
]);

export const DSA_REGULATED_COUNTRY_CODES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE'
]);

export const RESTRICTED_DETAILED_TARGETING_SPECIAL_AD_CATEGORY_IDS = new Set([
  'HOUSING',
  'EMPLOYMENT',
  'FINANCIAL_PRODUCTS_SERVICES'
]);

export const supportedImageMimeTypes = new Set(['image/jpeg', 'image/png']);
export const supportedVideoMimeTypes = new Set([
  'video/mp4',
  'video/quicktime'
]);
export const supportedMediaContentTypeByExtension: Record<string, string> = {
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  png: 'image/png'
};

export const rawDataKeys = [
  'id',
  'key',
  'name',
  'type',
  'path',
  'description',
  'topic',
  'disambiguation_category',
  'audience_size',
  'audience_size_lower_bound',
  'audience_size_upper_bound',
  'country_code',
  'country_name',
  'region',
  'region_id',
  'latitude',
  'longitude'
];
